import React from 'react';
import InfoTooltip from '../tooltips/InfoTooltip';
import CountField from '../fields/CountField';
import {useSelector} from 'react-redux';
import {useFormState} from 'react-final-form';
import useFieldRules from '../../hooks/useFieldRules';
import useSyncedField from '../../hooks/useSyncedField';
import Tooltips from '../../helpers/fieldTooltips';
import {universalPagesValidation} from '../../helpers/universalPagesValidation';

function Question() {
    const {limits} = useSelector(state => state.orderOptions.data);
    const {values} = useFormState();

    if (!limits || !limits.question) return null;

    const {isVisible} = useFieldRules('question');
    useSyncedField('question', 'int');

    if (!isVisible) return null;

    return (
        <div className="form-group form-control-pages">
            <div className="form-label d-flex">
                {limits && limits.question ? limits.question.label : ''}
                {values && values.question > 1 ? 's' : ''}
                <InfoTooltip>
                    <p>{Tooltips.question}</p>
                </InfoTooltip>
            </div>
            <div className="calculator-pages">
                <CountField
                    name="question"
                    validate={universalPagesValidation('question')}
                />
            </div>
        </div>
    );
}

export default Question;
